<template>
    <ul>
        <li v-for="(code, codeIndex) in codes">
            <div class="codeDiv">
                <cic-textbox
                    :enabled="!code.readOnly"
                    :value="code.code"
                    :maxlength="256"
                    @input="(val) => updateCode(codeIndex, 'code', val)"
                />
            </div>
            <div v-if="!failure" class="dynamicDiv">
                <span>{{ $t('Dynamic') }}</span>
                <cic-checkbox
                    :value="code.intervalType === 4"
                    @input="(val) => updateCode(codeIndex, 'intervalType', val ? 4 : 0)"
                />
            </div>
            <div v-if="!failure && previewMode" class="retryInPreviewDiv">
                <span>{{ $t('Retry in preview mode?') }}</span>
                <cic-checkbox
                    :value="code.retryInPreviewMode"
                    @input="(val) => updateCode(codeIndex, 'retryInPreviewMode', val)"
                />
            </div>
            <icon-button v-if="codes.length > 1" icon="remove-icon" @click="removeCode(codeIndex)" />
            <icon-button
                v-if="limit > codes.length && codeIndex === codes.length - 1"
                icon="add-icon"
                @click="addCode"
            />
            <template v-if="!failure">
                <edit-rule-set
                    v-if="code.intervalType === 4"
                    :rules="code.rules"
                    :parameters="parameters"
                    class="ruleSetList"
                    @input="(val) => updateCode(codeIndex, 'rules', val)"
                />
                <div v-else class="defaultOptionsDiv">
                    <edit-interval
                        :item="code"
                        :parameters="parameters"
                        @input="(val) => updateCodeInterval(codeIndex, val)"
                    />
                </div>
            </template>
        </li>
    </ul>
</template>

<script>
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import CicTextbox from '@/components/inputs/CicTextbox';
    import IconButton from '@/components/controls/IconButton';
    import EditInterval from './EditInterval';
    import EditRuleSet from './EditRuleSet';

    export default {
        name: 'EditCompletionCodes',
        components: {
            EditInterval,
            EditRuleSet,
            IconButton,
            CicCheckbox,
            CicTextbox,
        },
        props: {
            codes: {
                type: Array,
                required: true,
            },
            parameters: {
                type: Object,
                required: true,
            },
            failure: {
                type: Boolean,
                default: false,
            },
        },
        emits: ['input'],
        computed: {
            limit() {
                return this.parameters.REDDIAL_RETRY_PROFILE_CODE_LIMIT
                    ? parseInt(this.parameters.REDDIAL_RETRY_PROFILE_CODE_LIMIT)
                    : 10;
            },
            previewMode() {
                return !!(
                    this.parameters.DialEnableRetryInPreviewMode && this.parameters.DialEnableRetryInPreviewMode === '1'
                );
            },
        },
        methods: {
            addCode() {
                let codes = JSON.parse(JSON.stringify(this.codes));
                codes.push({
                    code: '',
                    readOnly: false,
                    intervalType: 0,
                    intervalMS: 1,
                    intervalSessions: 0,
                    retryDate: null,
                    retryTime: null,
                    retryInPreviewMode: false,
                    rules: [],
                });
                this.$emit('input', codes);
            },

            removeCode(index) {
                let codes = JSON.parse(JSON.stringify(this.codes));
                codes.splice(index, 1);
                this.$emit('input', codes);
            },

            updateCode(index, field, val) {
                let codes = JSON.parse(JSON.stringify(this.codes));
                codes[index][field] = val;
                if (field === 'intervalType') {
                    codes[index]['rules'] = [];
                    if (val === 4) {
                        codes[index]['rules'] = [
                            {
                                intervalType: 0,
                                intervalMS: 1,
                                intervalSessions: 0,
                                retryDate: null,
                                retryTime: null,
                                priority: 1,
                                properties: [
                                    {
                                        property: 'Age (Hours)',
                                        condition: '=',
                                        value: '',
                                    },
                                ],
                            },
                        ];
                    }
                }

                this.$emit('input', codes);
            },

            updateCodeInterval(index, val) {
                let codes = JSON.parse(JSON.stringify(this.codes));
                val.forEach((x) => (codes[index][x.field] = x.value));
                this.$emit('input', codes);
            },
        },
    };
</script>
